import { Xt as e } from "./app-runtime-DO23oeGx.mjs";
//#region src/utils/browserErrorReporter.ts
var t = e("browserErrorReporter"), n = "/v1/client-logs/browser", r = 5e3, i = 600, a = 2, o = 16, s = 8, c = /* @__PURE__ */ new Map(), l = !1, u = null, d = /token|secret|password|authorization|cookie|session|credential|apikey|api_key/i;
function f(e, t = i) {
	return e.length > t ? `${e.slice(0, t)}...` : e;
}
function p(e) {
	return f(e.replace(/Bearer\s+[A-Za-z0-9._~+/-]+=*/gi, "Bearer [redacted]").replace(/\b[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, "[redacted.jwt]").replace(/([?&](?:access_token|auth|code|password|refresh_token|session|token)=)[^&#\s]+/gi, "$1[redacted]").replace(/\b(access_token|auth|code|password|refresh_token|session|token)=\S+/gi, "$1=[redacted]").replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, "[redacted.email]"));
}
function m(e) {
	return typeof e == "string" ? p(e) : e instanceof Error ? p(e.message || e.name) : e === null ? "null" : e === void 0 ? "undefined" : typeof e == "number" || typeof e == "boolean" ? String(e) : Array.isArray(e) ? `[array:${e.length}]` : typeof e == "object" ? `[object:${e.constructor?.name ?? "Object"}]` : p(String(e));
}
function h(e) {
	if (e) try {
		let t = new URL(e, typeof window > "u" ? "http://localhost" : window.location.origin);
		return p(`${t.origin}${t.pathname}`);
	} catch {
		return p(e.split("?")[0].split("#")[0]);
	}
}
function g(e) {
	if (e) return e.split("\n").slice(0, s).map((e) => p(e)).join("\n");
}
function _(e, t = 0) {
	if (e == null || typeof e == "number" || typeof e == "boolean") return e;
	if (typeof e == "string") return p(e);
	if (e instanceof Error) return {
		name: e.name,
		message: p(e.message),
		stack: g(e.stack)
	};
	if (t >= a) return m(e);
	if (Array.isArray(e)) return e.slice(0, o).map((e) => _(e, t + 1));
	if (typeof e == "object") {
		let n = {};
		for (let [r, i] of Object.entries(e).slice(0, o)) n[r] = d.test(r) ? "[redacted]" : _(i, t + 1);
		return n;
	}
	return m(e);
}
function v(e) {
	return e.map((e) => e instanceof Error ? `Error:${e.name}` : Array.isArray(e) ? "array" : typeof e);
}
function y(e) {
	if (!e) return !1;
	let t = e.toLowerCase();
	return t === "canceled" || t.includes("err_canceled");
}
function b(e) {
	return !!(e.level !== "warn" && e.level !== "error" || y(e.message));
}
function x(e) {
	let t = Date.now();
	for (let [e, n] of c.entries()) t - n > r && c.delete(e);
	let n = c.get(e);
	return n && t - n < r ? !1 : (c.set(e, t), !0);
}
function S(e) {
	return {
		enabled: e.enabled === !0,
		endpoint: e.endpoint ?? n,
		captureConsole: e.captureConsole === !0,
		includeUserAgent: e.includeUserAgent === !0
	};
}
function C(e, t) {
	return {
		level: e.level,
		type: p(e.type),
		message: p(e.message || "Unknown browser event"),
		source: h(e.source),
		stack: g(e.stack),
		url: h(typeof window > "u" ? e.url : window.location.href),
		userAgent: t.includeUserAgent && typeof window < "u" ? p(window.navigator.userAgent) : void 0,
		details: _(e.details)
	};
}
function w(e, n) {
	if (typeof window > "u" || !n.enabled || b(e)) return;
	let r = C(e, n);
	if (!x(`${r.type}:${r.message}:${r.source ?? ""}`)) return;
	let i = JSON.stringify(r);
	try {
		if (typeof navigator.sendBeacon == "function") {
			let e = new Blob([i], { type: "application/json" });
			navigator.sendBeacon(n.endpoint, e);
			return;
		}
		fetch(n.endpoint, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: i,
			keepalive: !0
		});
	} catch (e) {
		t.debug("Unable to send browser error report", e);
	}
}
function T(e = {}) {
	let t = S(e);
	if (typeof window > "u" || !t.enabled) return () => void 0;
	u?.();
	let n = (e) => {
		w({
			level: "error",
			type: "window.error",
			message: e.message || "Unknown window error",
			source: e.filename,
			details: {
				line: e.lineno,
				column: e.colno
			},
			stack: e.error instanceof Error ? e.error.stack : void 0
		}, t);
	}, r = (e) => {
		let n = e.reason;
		w({
			level: "error",
			type: "window.unhandledrejection",
			message: m(n),
			stack: n instanceof Error ? n.stack : void 0,
			details: { reasonType: v([n])[0] }
		}, t);
	};
	window.addEventListener("error", n), window.addEventListener("unhandledrejection", r);
	let i = {
		debug: console.debug.bind(console),
		info: console.info.bind(console),
		log: console.log.bind(console),
		warn: console.warn.bind(console),
		error: console.error.bind(console)
	};
	if (t.captureConsole) {
		let e = (e, n) => (...r) => {
			if (i[e](...r), !l) try {
				l = !0, w({
					level: n,
					type: `console.${e}`,
					message: r.map((e) => m(e)).join(" "),
					details: {
						argCount: r.length,
						argTypes: v(r)
					}
				}, t);
			} finally {
				l = !1;
			}
		};
		console.debug = e("debug", "debug"), console.info = e("info", "info"), console.log = e("log", "info"), console.warn = e("warn", "warn"), console.error = e("error", "error");
	}
	let a = () => {
		window.removeEventListener("error", n), window.removeEventListener("unhandledrejection", r), t.captureConsole && (console.debug = i.debug, console.info = i.info, console.log = i.log, console.warn = i.warn, console.error = i.error), u === a && (u = null);
	};
	return u = a, a;
}
//#endregion
export { T as t };
